import { Schema as S } from "effect";

/** Integrations endpoints are called inline in v1 (Integrations.tsx); shapes kept loose. */
export const ApiKey = S.Struct({
	id: S.String,
	description: S.NullOr(S.String),
	createdAt: S.String,
});
export type ApiKey = typeof ApiKey.Type;
export const ApiKeyList = S.Struct({ data: S.Array(ApiKey) });

/** `id` is the new agent: the Agents page preselects it to share. */
export const CreatedApiKey = S.Struct({ id: S.String, key: S.String });
